"use client";

import React from "react";
import {
  BlogAuthor,
  BlogDetails,
} from "@/.storyblok/types/319751/storyblok-components";
import { storyblokEditable, SbBlokData } from "@storyblok/react";
import Image from 'next/image';

interface BlogIntroProps {
  blok?: BlogDetails & SbBlokData;
  blog_author?: (BlogAuthor & SbBlokData)[];
}

const BlogIntro: React.FC<BlogIntroProps> = ({ blok, blog_author = [] }) => {
  const firstAuthor = Array.isArray(blog_author) && blog_author.length > 0 ? blog_author[0] : null;

  const formatBlogDate = (dateString: string) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Get date from blok
  const blogDate = formatBlogDate(typeof blok?.date === 'string' ? blok.date : new Date().toISOString());

  // Get author data
  const authorName = firstAuthor?.name ?? '';
  const authorTitle = firstAuthor?.title ?? '';
  const authorImage = firstAuthor?.image?.filename ?? '';

  if (!blok) return null;

  return (
    <>
      <div {...storyblokEditable(blok)} className="bg-light py-3">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-18 col-xl-16 d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                {authorImage && (
                  <Image
                    src={authorImage}
                    width={50}
                    height={50}
                    alt={`${authorName} Headshot`}
                    className="rounded-circle"
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    loading="lazy"
                    quality={75}
                  />
                )}
                <div className="ms-3">
                  <h5 className="text-secondary me-2 mb-0">{authorName}</h5>
                  <span className="blog-author-title text-dark">{authorTitle}</span>
                </div>
              </div>
              <div className="blog-author-meta ms-2">
                <i className="fas fa-calendar me-2"></i>{blogDate}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogIntro;